import SvgIcon from '@mui/material/SvgIcon';

export default function LogoutIcon(props) {
  return (
    <SvgIcon {...props}>
      <path fill="currentColor" d="M18.1111 8.61111L17.0928 9.62944L18.2339 10.7778H12.3333V12.2222H18.2339L17.0928 13.3633L18.1111 14.3889L21 11.5L18.1111 8.61111ZM9.44444 6.44444H14.5V5H9.44444C8.65 5 8 5.65 8 6.44444V16.5556C8 17.35 8.65 18 9.44444 18H14.5V16.5556H9.44444V6.44444Z" />
    </SvgIcon>
  );
}